var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progress-bar" }, [
    _vm.totalTasks > 0
      ? _c("p", [_vm._v("\n    " + _vm._s(_vm.tasksString) + "\n  ")])
      : _vm._e(),
    _c(
      "p",
      [
        _vm.totalTasks > 0
          ? _c("KLinearLoader", {
              staticClass: "k-linear-loader",
              style: { backgroundColor: _vm.$themeTokens.fineLine },
              attrs: {
                delay: false,
                progress: _vm.progress,
                type: "determinate",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _c(
      "p",
      [
        _vm.showClearCompletedButton
          ? _c("KButton", {
              attrs: {
                appearance: "basic-link",
                text: _vm.getTaskString("clearCompletedTasksAction"),
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("clearall")
                },
              },
            })
          : _vm._e(),
        _c("span", [_vm._v("  ")]),
        _c("KRouterLink", {
          attrs: {
            appearance: "basic-link",
            text: _vm.$tr("taskManagerLink"),
            to: _vm.taskManagerLink,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }